module.exports = __webpack_public_path__ + "static/media/profile-icon-sm.3e568521.svg";